import * as React from 'react';
import { ReportingTab } from '../../types/reporting.type';
import { AUTH_GROUPS } from '../../constants';
import DownloadReports from '../../views/Reporting/components/BRReports/Downloads/DownloadReports';

const reportingTabs = {
    DOWNLOADS: {
        label: 'Downloads',
        component: <DownloadReports key={'DownloadReports_tab'} reportName={'Downloads'} />,
    },
};

const adminTabs: ReportingTab[] = [reportingTabs.DOWNLOADS];
const carrierRepTabs: ReportingTab[] = [];

const accountManagerTabs: ReportingTab[] = [];

const getAvailableReportingTabs = (group: string) => {
    switch (group) {
        case AUTH_GROUPS.ADMIN:
            return adminTabs;
        case AUTH_GROUPS.CARRIER_REP:
            return carrierRepTabs;
        case AUTH_GROUPS.UNDERWRITER:
        case AUTH_GROUPS.ACCOUNT_MANAGER:
            return accountManagerTabs;
        default:
            return [];
    }
};

export const getReportingTabs = (group: string): ReportingTab[] => {
    return getAvailableReportingTabs(group);
};
